import { generatePath } from "react-router-dom";
import type { AiTemplateId } from "@gs/core/domain/AiTemplate/AiTemplate";

export const templateIdParamName = "templateId";
export const templatesPath = "/templates";
export const templatePath = `${templatesPath}/:${templateIdParamName}`;

export const templatesPageScopeParamValues = ["my", "team"] as const;
export type TemplatesPageScopeParamValue = typeof templatesPageScopeParamValues[number];
export const getIsTemplatesPageScopeParamValue = (value: unknown): value is TemplatesPageScopeParamValue => {
  if (typeof value !== "string") return false;
  return templatesPageScopeParamValues.includes(value as any);
};

export const templatesPageChannelParamValues = ["linkedin", "email"] as const;
export type TemplatesPageChannelParamValue = typeof templatesPageChannelParamValues[number];
export const getIsTemplatesPageChannelParamValue = (value: unknown): value is TemplatesPageChannelParamValue => {
  if (typeof value !== "string") return false;
  return templatesPageChannelParamValues.includes(value as any);
};

export const templatesPageQueryParams = {
  SEARCH: "q",
  SCOPE: "scope",
  CHANNEL: "channel",
} as const;

export const getLinkToTemplatesPage = (args?: {
  templateId?: AiTemplateId
  query?: string
  scope?: TemplatesPageScopeParamValue
  channel?: TemplatesPageChannelParamValue
}) => {
  const pathname = args?.templateId
    ? generatePath(templatePath, { [templateIdParamName]: args?.templateId })
    : generatePath(templatesPath);

  const urlSearchParams = new URLSearchParams();
  if (args?.query) urlSearchParams.set(templatesPageQueryParams.SEARCH, JSON.stringify(args?.query));
  if (args?.channel) urlSearchParams.set(templatesPageQueryParams.CHANNEL, JSON.stringify(args?.channel));
  if (args?.scope) urlSearchParams.set(templatesPageQueryParams.SCOPE, JSON.stringify(args?.scope));

  const search = urlSearchParams.toString();

  if (!search) return pathname;
  return `${pathname}?${search}`;
};

export default templatesPath;
